import moment from 'moment-timezone';

/**
 * Formats a timezone name to include abbreviation and UTC offset
 * @param {string} timezoneName - The timezone name (e.g., "America/Chicago")
 * @returns {string} - Formatted string (e.g., "America/Chicago (CST, UTC-6)")
 */
export const formatTimezoneDisplay = (timezoneName) => {
  try {
    // Get current moment in the timezone
    const now = moment().tz(timezoneName);
    
    // Get the abbreviation (e.g., "CST", "EST")
    const abbreviation = now.format('z');
    
    // Get the UTC offset (e.g., "-06:00", "+05:30")
    const offsetString = now.format('Z');
    
    // Convert offset to simpler format (e.g., "UTC-6", "UTC+5:30")
    const offsetHours = Math.floor(Math.abs(now.utcOffset()) / 60);
    const offsetMinutes = Math.abs(now.utcOffset()) % 60;
    const offsetSign = now.utcOffset() >= 0 ? '+' : '-';
    
    let utcOffset;
    if (offsetMinutes === 0) {
      utcOffset = `UTC${offsetSign}${offsetHours}`;
    } else {
      utcOffset = `UTC${offsetSign}${offsetHours}:${offsetMinutes.toString().padStart(2, '0')}`;
    }
    
    // Format the display name
    const displayName = timezoneName.replace(/_/g, ' ');
    
    return `${displayName} (${abbreviation}, ${utcOffset})`;
  } catch (error) {
    // Fallback to original format if there's an error
    console.warn(`Error formatting timezone ${timezoneName}:`, error);
    return timezoneName.replace(/_/g, ' ');
  }
};

/**
 * Gets all timezone names with formatted display
 * @returns {Array} - Array of objects with value and label properties
 */
export const getFormattedTimezones = () => {
  return moment.tz.names()
    .filter(tz => tz.includes('/')) // Filter for region-based timezones
    .map(tzName => ({
      value: tzName,
      label: formatTimezoneDisplay(tzName)
    }))
    .sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically by display label
};